function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

var Points = function (_Component) {
    _inherits(Points, _Component);

    function Points() {
        var _temp, _this, _ret;

        _classCallCheck(this, Points);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getClassName = function (id, serieId) {
            var _this$props = _this.props,
                currentPoint = _this$props.currentPoint,
                currentSlice = _this$props.currentSlice;


            var classNames = [];

            var pointClass = "point--" + id.toString().replace('.', '-');
            var serieClass = "serie--" + serieId.toString().replace('.', '-');

            classNames.push('point');
            classNames.push(pointClass);
            classNames.push(serieClass);

            var isCurrent = void 0;

            if (currentPoint && currentPoint.id && currentPoint.id === id) {
                isCurrent = true;
            }

            if (currentSlice && currentSlice.points) {

                var inCurrentSlice = currentSlice.points.filter(function (point) {
                    if (point.id === id) {
                        return true;
                    }
                });

                if (inCurrentSlice.length) {
                    isCurrent = true;
                }
            }

            if (isCurrent) {
                classNames.push('point--is-current');
            }

            return classNames.join(' ');
        }, _this.renderPoint = function (point, index) {
            var id = point.id,
                serieId = point.serieId,
                serieColor = point.serieColor,
                x = point.x,
                y = point.y;


            var className = _this.getClassName(id, serieId);
            var transform = "translate(" + x + ", " + y + ")";

            return React.createElement('circle', { transform: transform, className: className, r: '2', fill: 'transparent', stroke: serieColor, strokeWidth: '4' });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Points.prototype.render = function render() {
        var points = this.props.points;


        return React.createElement(
            'g',
            { className: 'points' },
            points.map(this.renderPoint)
        );
    };

    return Points;
}(Component);

export default Points;